(function (ws) {
    'use strict';

    ws.views.CustomerOnboardingLandingPage = Backbone.View.extend({

        events: {
            'click .searchBtnCls': 'findProspectUser',
            'keyup #prospectNumber': 'handleEnter',
            'click .checkStatus': 'getProspectStatus',
            'change input.prospectTypeSelector': 'toggleProspectType'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$prospectId = this.$('#prospectNumber');
            this.$prospectError = this.$('.prospectError');
            this.$prospectStatusError = this.$('.prospectStatusError');
            this.$prospectNotFoundError = this.$('.prospectStatusNotFoundError');
            this.$prospectEmailNotFoundError = this.$('.prospectEmailNotFoundError');
            this.statusField = this.$('.statusField');
            this.notAvailable = this.$('#notAvailable');

            this.partnerStatus = {
                OPEN: $('#partnerOpen').val(),
                IN_PROGRESS: $('#partnerInProgress').val(),
                ACTIVATED: $('#partnerInProgress').val(),
                SUBMITTED: $('#partnerSubmitted').val(),
                SALES_SUBMIT: $('#partnerSalesSubmitted').val(),
                FINANCE_SUBMIT: $('#partnerFinanceSubmitted').val(),
                SPECIALIST_SUBMIT: $('#partnerFinanceSubmitted').val(),
                COMPLETED: $('#partnerCompleted').val(),
                REJECTED: $('#partnerRejected').val()
            };

            this.reburaCustomerStatus = {
                OPEN: $('#reburaCustomerOpen').val(),
                IN_PROGRESS: $('#reburaCustomerInProgress').val(),
                ACTIVATED: $('#reburaCustomerInProgress').val(),
                SUBMITTED: $('#reburaCustomerSubmitted').val(),
                SALES_SUBMIT: $('#reburaCustomerSalesSubmitted').val(),
                FINANCE_SUBMIT: $('#reburaCustomerFinanceSubmitted').val(),
                SPECIALIST_SUBMIT: $('#reburaCustomerFinanceSubmitted').val(),
                COMPLETED: $('#reburaCustomerCompleted').val(),
                REJECTED: $('#reburaCustomerRejected').val()
            };

            this.academypartnerStatus = {
                OPEN: $('#academypartnerOpen').val(),
                IN_PROGRESS: $('#academypartnerInProgress').val(),
                ACTIVATED: $('#academypartnerInProgress').val(),
                SUBMITTED: $('#academypartnerSubmitted').val(),
                SALES_SUBMIT: $('#academypartnerSalesSubmitted').val(),
                FINANCE_SUBMIT: $('#academypartnerFinanceSubmitted').val(),
                SPECIALIST_SUBMIT: $('#academypartnerFinanceSubmitted').val(),
                COMPLETED: $('#academypartnerCompleted').val(),
                REJECTED: $('#academypartnerRejected').val()
            };

            this.supplierStatus = {
                OPEN: $('#supplierOpen').val(),
                IN_PROGRESS: $('#supplierInProgress').val(),
                ACTIVATED: $('#supplierInProgress').val(),
                SUBMITTED: $('#supplierSubmitted').val(),
                PURCHASE_SUBMIT: $('#supplierApprover').val(),
                FINANCE_SUBMIT: $('#supplierFinanceSubmitted').val(),
                COMPLETED: $('#supplierCompleted').val(),
                REJECTED: $('#supplierRejected').val()
            };

            this.masterAgentStatus = {
                OPEN: $('#masterAgentOpen').val(),
                IN_PROGRESS: $('#masterAgentInProgress').val(),
                ACTIVATED: $('#masterAgentInProgress').val(),
                SUBMITTED: $('#masterAgentSubmitted').val(),
                SPECIALIST_SUBMIT: $('#masterAgentSpecialistSubmitted').val(),
                COMPLETED: $('#masterAgentCompleted').val(),
                REJECTED: $('#masterAgentRejected').val()
            };

            this.formWithPartner = {
                Partner: ['OPEN', 'IN_PROGRESS', 'REJECTED', 'ACTIVATED'],
                Sales: ['SUBMITTED'],
                Finance: ['SALES_SUBMIT'],
                'Application is complete': ['COMPLETED'],
                MDM: ['FINANCE_SUBMIT']
            };

            this.formWithReburaCustomer = {
                'Rebura Customer': ['OPEN', 'IN_PROGRESS', 'REJECTED', 'ACTIVATED'],
                Sales: ['SUBMITTED'],
                Finance: ['SALES_SUBMIT'],
                'Application is complete': ['COMPLETED'],
                MDM: ['FINANCE_SUBMIT']
            };
            this.academyformWithPartner = {
                Training: ['OPEN', 'IN_PROGRESS', 'REJECTED', 'ACTIVATED'],
                Sales: ['SUBMITTED'],
                Finance: ['SALES_SUBMIT'],
                'Application is complete': ['COMPLETED'],
                MDM: ['FINANCE_SUBMIT']
            };

            this.formWithSupplier = {
                Supplier: ['OPEN', 'IN_PROGRESS', 'REJECTED', 'ACTIVATED'],
                'Supplier Approver': ['SUBMITTED'],
                Finance: ['PURCHASE_SUBMIT'],
                'Application is complete': ['COMPLETED'],
                MDM: ['FINANCE_SUBMIT']
            };

            this.formWithAgent = {
                'Master agent': ['OPEN', 'IN_PROGRESS', 'REJECTED', 'ACTIVATED'],
                'Master agent Specialist': ['SUBMITTED'],
                'Application is complete, Please contact Master agent specialist for further details': ['COMPLETED'],
                MDM: ['SPECIALIST_SUBMIT']
            };

            this.companyLabel = {
                CUSTOMER: 'Partner Name:',
                VENDOR: 'Supplier Name:',
                ACADEMY_PARTNER: 'Training Name',
                REBURA_CUSTOMER: 'Rebura Customer Name:'
            };
        },

        toggleProspectType: function () {
            $('.internal-user-menu').addClass('hide');
            $('input[name="typeSelector"]:checked').parent().next().removeClass('hide');
            $('#prospectStatusNumber').val('');
            this.statusField.addClass('hide');
            this.$prospectStatusError.hide();
            this.$prospectNotFoundError.hide();
            this.$prospectError.hide();
            this.$prospectEmailNotFoundError.hide();
        },

        getProspectStatus: function () {
            let prospectId = {prospectId: $('#prospectStatusNumber').val()};

            if (prospectId.prospectId === '') {
                this.$prospectStatusError.show();
                this.statusField.addClass('hide');
                this.$prospectNotFoundError.hide();
                this.$prospectEmailNotFoundError.hide();
                return false;
            } else {
                this.$prospectStatusError.hide();
                this.$prospectNotFoundError.hide();
                this.$prospectEmailNotFoundError.hide();
            }

            this.getProspectStatusApi = new ws.models.getProspectStatus(prospectId);
            this.getProspectStatusApi.fetch().done((data) => {
                if (!data.error) {
                    this.statusField.html('');
                    let applicationHtml = '';

                    data.customerOnboardStatusList.forEach((response) => {
                        let html = `<div class='statusResult'><fieldset>`;
                        ['prospectId', 'prospectType', 'status', 'formWith', 'companyName'].forEach((field) => {
                            let responseData = response[field];

                            if (field === 'prospectType') {
                                if (response.prospectType === 'VENDOR') {
                                    responseData = 'Supplier';
                                } else if (response.prospectType === 'MASTER_AGENT') {
                                    responseData = 'Agent';
                                } else if (response.prospectType === 'ACADEMY_PARTNER') {
                                    responseData = 'Training';
                                } else if (response.prospectType === 'REBURA_CUSTOMER') {
                                    responseData = 'Rebura Customer';
                                } else {
                                    responseData = 'Partner';
                                }

                                this.$('.companyNameLabel').html(this.companyLabel[response.prospectType]);
                                html += `<div class="field">
                                    <div class="headLabel">Prospect Type:</div>
                                    <div class="value prospectType">${responseData}</div>
                                    </div>`;
                            }

                            if (field === 'status') {
                                let statusObj;
                                if (response.prospectType === 'VENDOR') {
                                    statusObj = this.supplierStatus;
                                } else if (response.prospectType === 'MASTER_AGENT') {
                                    statusObj = this.masterAgentStatus;
                                } else if (response.prospectType === 'ACADEMY_PARTNER') {
                                    statusObj = this.academypartnerStatus;
                                } else if (response.prospectType === 'REBURA_CUSTOMER') {
                                    statusObj = this.reburaCustomerStatus;
                                } else {
                                    statusObj = this.partnerStatus;
                                }

                                responseData = statusObj[response.status] ? (response.status === 'COMPLETED' ? statusObj[response.status] + ' ' + response.accountNumber : statusObj[response.status]) : '';
                                html += `<div class="field">
                                    <div class="headLabel">Status of the Application:</div>
                                    <div class="value status">${responseData}</div>
                                    </div>`;
                            }

                            if (field === 'formWith') {
                                let formWithObj;
                                if (response.prospectType === 'VENDOR') {
                                    formWithObj = this.formWithSupplier;
                                } else if (response.prospectType === 'MASTER_AGENT') {
                                    formWithObj = this.formWithAgent;
                                } else if (response.prospectType === 'ACADEMY_PARTNER') {
                                    formWithObj = this.academyformWithPartner;
                                } else if (response.prospectType === 'REBURA_CUSTOMER') {
                                    formWithObj = this.formWithReburaCustomer;
                                } else {
                                    formWithObj = this.formWithPartner;
                                }

                                Object.entries(formWithObj).forEach(([key, value]) => {
                                    if (value.indexOf(response.status) != -1) {
                                        responseData = key;
                                    }
                                });

                                html += `<div class="field">
                                    <div class="headLabel">Application is with:</div>
                                    <div class="value formWith">${responseData}</div>
                                    </div>`;
                            }

                            if (field === 'prospectId') {
                                responseData = ['OPEN', 'IN_PROGRESS', 'ACTIVATED'].includes(response.status) ? this.notAvailable.val() : responseData;
                                html += `<div class="field">
                                    <div class="headLabel">Prospect Id:</div>
                                    <div class="value prospectId">${responseData}</div>
                                    </div>`;
                            }

                            if (field === 'companyName') {
                                html += `<div class="field">
                                    <div class="headLabel companyNameLabel">Partner Name:</div>
                                    <div class="value companyName">${responseData ? responseData : ''}</div>
                                    </div>`;
                            }
                        });

                        html += `</fieldset></div>`;
                        applicationHtml += html;
                    });

                    applicationHtml += `<br>
                        <span>To view your local contact please
                        <a target="_blank" href="https://westcon1.sharepoint.com/sites/resources/emea/PartnerView%20documents/Forms/AllItems.aspx?sortField=Modified&isAscending=false&id=%2Fsites%2Fresources%2Femea%2FPartnerView%20documents%2FCORP%5FINT%5FPartnerSupplierOnboarding%5FContacts%2Epdf&parent=%2Fsites%2Fresources%2Femea%2FPartnerView%20documents">
                        click here</a></span>`;

                    this.statusField.html(applicationHtml);
                    this.statusField.removeClass('hide');
                } else {
                    if (isNaN(prospectId.prospectId)) {
                        this.$prospectEmailNotFoundError.show();
                    } else {
                        this.$prospectNotFoundError.show();
                    }

                    this.statusField.addClass('hide');
                }
            }).fail((exception) => {
                this.$prospectStatusError.html('Api Failed').show();
                this.statusField.addClass('hide');
            });
        },

        handleEnter: function(ev) {
            if (ev.which === 13 && ev.target.value) {
                this.findProspectUser();
            }
        },

        findProspectUser: function () {
            this.$prospectValue = this.$prospectId.val();
            if (this.$prospectValue === '') {
                this.$prospectError.show();
                return false;
            } else {
                this.$prospectError.hide();
            }

            $.ajax({
                url: globals.path.api.westcon.prospectIdSearch + this.$prospectValue,
                type: 'GET',
                contentType: 'application/json',
                success: (response) => {
                    if (response.success) {
                        this.$prospectError.hide();
                        window.location.replace(globals.path.api.westcon.redirectToForm + this.$prospectValue);
                    } else {
                        this.$prospectError.html(response.errorCode).show();
                    }
                },

                error: function(jqXHR, textStatus, errorThrown) {
                    console.log('error');
                }
            });
        }
    });
})(westcon);
